/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {TierListPageComponent} from './tier-list-page.component';

@Component({
  standalone: true,
  imports: [TierListPageComponent],
  selector: 'adn-tier-route-page',
  template: '<adn-tier-list-page [readOnly]="readOnly"></adn-tier-list-page>'
})
export class TierRoutePageComponent {
  @Input() readOnly = false;
}
